import { create } from 'zustand';

type PreventAutoReloadState = {
  preventReasons: Set<string>;
  addReason: (reason: string) => void;
  removeReason: (reason: string) => void;
  shouldPrevent: () => boolean;
};

export const usePreventAutoReloadOnNewVersion = create<PreventAutoReloadState>(
  (set, get) => ({
    preventReasons: new Set<string>(),

    addReason: (reason: string) => {
      set((state) => ({
        preventReasons: new Set(state.preventReasons).add(reason),
      }));
    },

    removeReason: (reason: string) => {
      set((state) => {
        const newReasons = new Set(state.preventReasons);
        newReasons.delete(reason);
        return { preventReasons: newReasons };
      });
    },

    shouldPrevent: () => {
      return get().preventReasons.size > 0;
    },
  }),
);
